export const api = {
  smartLibraryListing: '/smart-library-list',
  smartLibraryDetails: '/smart-library/{0}',
  smartLibrary: '/smart-library',
  smartLibraryProduct: '/smart-library-product',
  smartLibraryFileType: '/smart-library-file-type',
  eFormListing: '/smart-library/e-form/list',
  eFormDetails: '/smart-library/e-form/{0}',
  eForm: '/smart-library/e-form',
}
